export default function styles() {
  return {
    responsiveContainer: {
      '& svg': {
        width: '700px',
      },
    },
  }
}
